<template>
  <div class="company-management-box">
    <!-- <div class="form-info-box clearfix"> -->
    <card>
      <div class="form-btn-list">
        <cus-btn type="view" :disabled="!companyDataPermission" @click="companyInfoViewPage" v-if="buttonPerCheck('view')"/>
        <cus-btn type="edit" :disabled="!companyDataPermission" @click="companyInformationViewPage" v-if="buttonPerCheck('edit')"/>
        <cus-btn type="generate" :disabled="!companyDataPermission" v-if="buttonPerCheck('generate')" @click="generatePDF"/>
      </div>

      <div class="form-check-info">
        <div>
          {{ $t('formData.companyCode') }}：
          <span>{{ ruleForm.companyCode }}</span>
        </div>
        <div>
          {{ $t('formData.companyName') }}：
          <span>{{ ruleForm.companyName }}</span>
        </div>
        <div>
          {{ $t('formData.technicalArea') }}：
          <span>{{ ruleForm.technicalAreaName }}</span>
        </div>
        <div>
          {{ $t('formData.headQuarter') }}：
          <span>{{ ruleForm.headQuarter }}</span>
        </div>
        <div>
          {{ $t('formData.companyContactPerson') }}：
          <span>{{ ruleForm.companyContactPerson }}</span>
        </div>
        <div>
          {{ $t('formData.mobilePhone') }}：
          <span>{{ ruleForm.mobilePhone }}</span>
        </div>
        <div>
          {{ $t('formData.companyPhone') }}：
          <span>{{ ruleForm.companyPhone }}</span>
        </div>
        <div>
          {{ $t('formData.companyAddress') }}：
          <span>{{ ruleForm.companyAddress }}</span>
        </div>
      </div>
    </card>

    <card style="margin-top:10px;">
      <template #header>
        <card-header>{{ $t('formData.companyProcessInformation') }}</card-header>
      </template>
      <div class="content-list-box">
        <div class="content-list">
          <div v-for="(item, index) in tableList" :key="'table' + index" class="column-dom clearfix">
            <!--          <div class="hint-title-name">-->
            <!--            Company Name Company Name Company Name-->
            <!--          </div>-->

            <div class="title-info-box clearfix">
              <div class="title">{{ item.processName }}</div>
              <div class="text-btn">
                <!-- <el-button type="text" @click="openProcessDetailPage(item.id, item.companyId)" v-if="buttonPerCheck('viewProcess')">{{ $t('button.viewProcess') }}</el-button>
                <el-button type="text" @click="openProcessEditPage(item.id, item.companyId)" v-if="buttonPerCheck('editProcess')">{{ $t('button.editProcess') }}</el-button> -->

                <cus-btn type="view" @click="openProcessDetailPage(item.id, item.companyId)" v-if="buttonPerCheck('viewProcess')"/>
                <cus-btn type="edit" @click="openProcessEditPage(item.id, item.companyId)" v-if="buttonPerCheck('editProcess')"/>
              </div>
            </div>

            <!-- <div class="block-list-box">
              <div class="block-box">
                <div class="icon">
                  <i class="el-icon-ali-TechnicalArea" />
                </div>
                <div class="block-content">
                  <div class="title">{{ $t('formData.technicalArea') }}</div>
                  <div
                          v-for="(item1, index) in item.technicalAreaList"
                          :key="'technical' + index"
                          class="info"
                  >{{ item1 }}</div>
                </div>
              </div>

              <div class="block-box">
                <div class="icon">
                  <i class="el-icon-ali-status" />
                </div>
                <div class="block-content">
                  <div class="title">{{ $t('formData.status') }}</div>
                  <div class="info">{{ getStatus(item.status) }}</div>
                </div>
              </div>

              <div class="block-box">
                <div class="icon">
                  <i class="el-icon-ali-createdby" />
                </div>
                <div class="block-content">
                  <div class="title">{{ $t('formData.createdBy') }}</div>
                  <div class="info">{{ item.createName }}</div>
                </div>
              </div>

              <div class="block-box">
                <div class="icon">
                  <i class="el-icon-ali-time" />
                </div>
                <div class="block-content">
                  <div class="title">{{ $t('formData.createdTime') }}</div>
                  <div class="info">{{ item.createTime }}</div>
                </div>
              </div>
            </div> -->
            <stage-view :stageList="item.phases.filter(item=>{return item.status==0}).map((i)=>{return i.stageName})"></stage-view>
          </div>
        </div>

        <pagination-page :total="total" :current-page="pageNum" :change-fun="changeTablePage" />
      </div>

    </card>

    <el-dialog width="80%" :visible.sync="dialogVisible"> 
      <pdf-page ref="pdfPage"></pdf-page>
    </el-dialog> 

  </div>
</template>

<script>
import pdfPage from '@/views/homes/pdfPage.vue'
import {
  companyDetails,
  companySelectProcess,
  companySelectApprovalProcess
} from '../../api/companyManagement'
import {
  getSelectInfoAll,
  getAreaNoName,
  getSelectName
} from '../../utils/companyManagement'
import { baseEnumsSelectDictionariesType} from "../../api/enumInfo"
export default {
  components: {
    'pdf-page':pdfPage
  },
  data() {
    return {
      selectInfoObj: {
        technicalArea: '',
        entityType: '',
        numberEmployess: '',
        annualRevenue: '',
        headQuarter: ''
      },
      total: 0,
      companyId: 0,
      pageNum: 1,
      pageSize: 10,
      ruleForm: {
        technicalAreaList: []
      },
      tableList: [],
      dialogVisible:false,
      /** 公司数据权限 */
      companyDataPermission:true
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language
    }
  },
  watch: {
    lang() {
      this.getSelectInfo(1)
    }
  },
  mounted() {
    const self = this
    window.companyIndex = self
    self.companyId = self.$route.query.companyId || self.$store.state.user.userinfo.compantId
    self.getSelectInfo(1)
  },
  methods: {
    /**
     * 获取下拉框信息
     *  status 1 获取详情  0 不获取详情
     */
    getSelectInfo(status) {
      const self = this

      getSelectInfoAll(selectInfoObj => {
        baseEnumsSelectDictionariesType(1,"3").then(res=>{
            self.selectInfoObj = selectInfoObj
            self.selectInfoObj.technicalArea=res.data;
             if (status === 1) {
               self.getCompanyDetails()
               self.getCompanySelectProcess()
             }
        })
      })
    },

    /**
     * 获取公司详情
     */
    getCompanyDetails() {
      const self = this
      companyDetails({ id: self.companyId }).then(response => {
        if (response.code === 200) {
          // 年收入 有没有值
          if (
            response.data.annualRevenue &&
            self.selectInfoObj.annualRevenue.length
          ) {
            response.data.annualRevenueName = getSelectName(
              response.data.annualRevenue,
              self.selectInfoObj.annualRevenue
            )
          }

          // 公司类型 有没有值
          if (
            response.data.entityType &&
            self.selectInfoObj.entityType.length
          ) {
            response.data.entityTypeName = getSelectName(
              response.data.entityType,
              self.selectInfoObj.entityType
            )
          }

          // 员工人数 有没有值
          if (
            response.data.numberEmployess &&
            self.selectInfoObj.numberEmployess.length
          ) {
            response.data.numberEmployessName = getSelectName(
              response.data.numberEmployess,
              self.selectInfoObj.numberEmployess
            )
          }

          // 技术领域 有没有值
          if (
            response.data.technicalArea &&
            self.selectInfoObj.technicalArea.length
          ) {
            response.data.technicalAreaName = getSelectName(
              response.data.technicalArea,
              self.selectInfoObj.technicalArea
            )
          }

          // 公司地址
          if (
            response.data.companyAddress &&
            self.selectInfoObj.headQuarter.length
          ) {
            response.data.companyAddress = getAreaNoName(
              response.data.companyAddress,
              self.selectInfoObj.headQuarter
            )
          }

          // 总部
          if (
            response.data.headQuarter &&
            self.selectInfoObj.headQuarter.length
          ) {
            response.data.headQuarter = getAreaNoName(
              response.data.headQuarter,
              self.selectInfoObj.headQuarter
            )
          }

          if (
            response.data.companyFile &&
            Array.isArray(response.data.companyFile) &&
            response.data.companyFile.length
          ) {
            self.fileList = []
            response.data.companyFile.forEach(item => {
              self.fileList.push({
                name: item.fileName,
                url: item.fileUrl
              })
            })
          }

          self.ruleForm = response.data
        }else if(response.code === 403){
          this.companyDataPermission = false
        }
      })
    },

    /**
     * 调转到完善公司信息页面
     */
    companyInformationViewPage() {
      this.$router.push({
        name: 'companyInformationView',
        query: {
          companyId: this.ruleForm.id,
          backToPage: 'companyManagement'
        }
      })
    },

    /**
     * 调转到查看公司详情页面
     */
    companyInfoViewPage() {
      this.$router.push({
        name: 'companyInfoView',
        query: {
          companyId: this.ruleForm.id,
          backToPage: 'companyManagement'
        }
      })
    },

    /**
     * 跳转到查看公司流程页面
     */
    openProcessDetailPage(id, companyId) {
      this.$router.push({
        name: 'companyProcessView',
        query: {
          id: id,
          companyId: companyId,
          backToPage: 'companyManagement'
        }
      })
    },

    /**
     * 跳转到编辑公司流程页面
     */
    openProcessEditPage(id, companyId) {
      this.$router.push({
        name: 'companyProcessEdit',
        query: {
          id: id,
          companyId: companyId,
          backToPage: 'companyManagement'
        }
      })
    },

    /**
     * tab 分页的 change 方法
     */
    changeTablePage(currentPage, pageSize) {
      const self = this
      self.pageNum = currentPage
      self.pageSize = pageSize
      self.getCompanySelectProcess()
    },

    /**
     * 获取流程列表
     */
    getCompanySelectProcess() {
      const self = this
      companySelectApprovalProcess({
        companyId: self.companyId,
        pageNum: self.pageNum,
        pageSize: self.pageSize,
        needValidate:1  // 是否需要数据权限验证  0否  1是
      }).then(response => {
        if (response.code === 200) {
          self.tableList = []
          self.total = response.data.total
          if (response.data.list && response.data.list.length) {
            response.data.list.forEach(item => {
              item.statusName = self.getStatus(item.status)

              // 技术领域 有没有值
              if (
                item.technicalArea &&
                self.selectInfoObj.technicalArea.length
              ) {
                item.technicalAreaList = getSelectName(
                  item.technicalArea,
                  self.selectInfoObj.technicalArea
                ).split(',')
              }
            })

            self.tableList = response.data.list
          }
        }
      })
    },

    /**
     * 获取 流程状态(1-待审批 2-通过 3-拒绝 4-草稿)
     */
    getStatus(status) {
      const self = this
      let name = ''
      switch (status) {
        case 1:
          name = self.$t('formData.pending')
          break
        case 2:
          name = self.$t('formData.through')
          break
        case 3:
          name = self.$t('formData.refusedTo')
          break
        case 4:
          name = self.$t('formData.theDraft')
          break
        default:
          return name
      }
      return name
    },

    /**
     * 生成
     * 
     */
    generatePDF(){
      this.dialogVisible = true;
      this.$nextTick(()=>{
        this.$refs.pdfPage.init(this.ruleForm.id);
      })
    }
  }
}
</script>

<style scoped lang="scss">
.company-management-box {
  .form-btn-list {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
</style>
